import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CustomAnswer, CustomQuestion } from 'globals/store/events.data';
import { customQuestionsByEntityTypeReselector } from '../../store/reselectors/entity.reselector';
import { CoreEntityType } from 'globals/store/share.data';
import { Wrapper } from '../wrapper.component';
import { CustomQuestionsComponent, UpdateQuestionOutput } from './custom-questions.component';
import { Dictionary } from '@ngrx/entity';

@Component({
    selector: 'custom-questions-app',
    template: `
<custom-questions 
  [entity]="entity"
  [questions]="questions"
  (updateQuestion)="updateQuestion.emit($event)"
></custom-questions>
`,
    styles: [`
`],
    standalone: true,
    imports: [CustomQuestionsComponent],
})
export class CustomQuestionsAppComponent<E extends { customQuestions?: Dictionary<CustomAnswer>, id?: string }> extends Wrapper<CustomQuestionsAppComponent<E>> implements OnInit {
  @Input() entityType: CoreEntityType
  @Input() entity: E
  questions: CustomQuestion[] = []
  @Output() updateQuestion: EventEmitter<UpdateQuestionOutput> = new EventEmitter()

  ngOnInit() {
    this.selectProp(customQuestionsByEntityTypeReselector,  { type: this.entityType, id: this.entity.id }, 'questions')
  }
}

